module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/stream-http/~/readable-stream/lib/internal/streams/from-browser.js
 ** module id = 324
 ** module chunks = 0
 **/